import React, { useEffect, useState, useContext } from 'react'
import {
    BrowserRouter as Router,
    Link,
    Navigate,
    useNavigate,
    useParams,
    useSearchParams
} from "react-router-dom"
import { GlobalContext } from '../GlobalContext'
import YellowAlert from '../ui-elements/YellowAlert'
import Card from '../ui-elements/Card'
import Button from '../formfields/Button'


type Props = {
    loadAlreadyExpanded?: boolean
    redirectBaseUrl?: string
}

function FilterChecklistCategories({
    loadAlreadyExpanded = false,
    redirectBaseUrl = "/"
}: Props) {

    const {
        t,
        tableData,
        currentOrganisation,
        sendMessageToWebsocket,
    } = useContext(GlobalContext)

    const navigate = useNavigate()
    const [showFullComponent, setShowFullComponent] = useState(loadAlreadyExpanded)
    const [searchParams] = useSearchParams()
    const filters = searchParams.getAll('filter')




    const handleCheckboxChange = (categoryId: string, checked: boolean) => {
        let querystring = ''
        const categoryIdsToFilterBy = [...filters]

        if (checked) {
            categoryIdsToFilterBy.push(categoryId)
        } else {
            const index = categoryIdsToFilterBy.indexOf(categoryId)
            if (index > -1) {
                categoryIdsToFilterBy.splice(index, 1)
            }
        }

        categoryIdsToFilterBy.forEach((categoryId, index) => {
            if (index === 0) {
                querystring += `?filter=${categoryId}`
            } else {
                querystring += `&filter=${categoryId}`
            }
        })

        const currentQuerystring = window.location.search
        if (currentQuerystring !== querystring) {
            navigate(`${redirectBaseUrl}${querystring}`)
        }

        localStorage.setItem(`checklistCategoryFilters-${currentOrganisation}`, JSON.stringify(categoryIdsToFilterBy))
    }




    if (!tableData || !tableData.ChecklistCategories || Object.keys(tableData.ChecklistCategories).length === 0) {
        return null
    }


    return <Card fullwidth={true}>

        <div className={`w-full flex flex-col gap-2`}>

            <div className={`w-full flex flex-row items-center justify-between gap-4`}>
                <div className={`flex flex-col gap-1`}>
                    <h3 className={`font-righteous text-brandblue text-lg`}>{t("Dashboard.FilterChecklistCategories.heading")}</h3>
                    {filters.length > 0 && <p className={`text-xs`}>{t("Dashboard.FilterChecklistCategories.categoriesSelected")} {filters.length} </p>}
                </div>


                {!showFullComponent && <Button
                    text={t("Dashboard.FilterChecklistCategories.showFilterCriteria")}
                    variant={`primary`}
                    fullwidth={false}
                    onClick={() => { setShowFullComponent(true) }}
                />}
                {showFullComponent && <Button
                    text={t("Dashboard.FilterChecklistCategories.hideFilterCriteria")}
                    variant={`primary`}
                    fullwidth={false}
                    onClick={() => { setShowFullComponent(false) }}
                />}
            </div>

            {showFullComponent && Object.keys(tableData.ChecklistCategories).length > 0 &&
                <div className={`flex flex-row flex-wrap gap-2`}>

                    {Object.keys(tableData.ChecklistCategories).map((categoryId: any) => {
                        const thisCategory = tableData.ChecklistCategories[categoryId]
                        const thisCategoryValueIds = thisCategory.Values ? Object.keys(thisCategory.Values) : []

                        return <div key={categoryId} className={`rounded px-2 py-2 bg-white border-gray-300 border flex flex-col gap-2`}>
                            <h4 className={`font-bold`}>{thisCategory.DisplayName}</h4>
                            {thisCategoryValueIds.length === 0 && <p className={`text-xs`}>{t('Dashboard.FilterChecklistCategories.noValues')}</p>}
                            {thisCategoryValueIds.length > 0 && <div className={`flex flex-col flex-wrap gap-4`}>

                                {thisCategoryValueIds.map((valueId: any) => {
                                    const thisValue = thisCategory.Values[valueId]
                                    const isThisChecked = filters.includes(valueId) ? true : false
                                    return <div key={valueId} className={`flex flex-row gap-1 items-center`}>
                                        <input
                                            type='checkbox'
                                            className={`w-4 h-4`}
                                            name={`ChecklistCategories[${categoryId}][${valueId}]`}
                                            id={`ChecklistCategories[${categoryId}][${valueId}]`}
                                            value={thisValue.DisplayName}
                                            checked={isThisChecked ? true : false}
                                            onChange={(e) => { handleCheckboxChange(valueId, e.target.checked) }}
                                        />
                                        <label htmlFor={`ChecklistCategories[${categoryId}][${valueId}]`} className={`text-sm`}>{thisValue.DisplayName}</label>
                                    </div>
                                })}

                            </div>}

                        </div>
                    })}
                </div>}



        </div>
    </Card>
}



export default FilterChecklistCategories